import axios from 'axios';

const apiBaseUrl = 'https://api.dryftwell.com';

export const login = async (firebase_token, email) => {
  axios.post(
    apiBaseUrl + '/locals',
    { firebase_token, email },
    {
      headers: {
        'Access-Control-Allow-Origin': '*',
      },
    },
  );
};
